// This file is generated and hand-edited. Source of truth for the "generic" namespace.
// See docs/locales.md for naming conventions and tooling.

export const generic = {
  project: {
    name: "CoTreatMe",
  },
  status: {
    new: "New",
    pending: "Pending",
    accepted: "Accepted",
    completed: "Completed",
    created: "Created",
    rejected: "Declined",
    expired: "Expired",
    revoked: "Revoked",
    canceled: "Canceled",
    none: "None",
    hidden: "Hidden",
    optional: "Optional",
    optionalBracket: "(Optional)",
  },
  messages: {
    contractTypeNotReadyForSignature: "This contract type cannot be created as a draft yet.",
    success: {
      add: "{entity} successfully added",
      edit: "{entity} successfully updated",
      confirm: "{entity} successfully confirmed",
      create: "{entity} successfully created",
      upload: "{entity} successfully uploaded",
      delete: "{entity} successfully deleted",
      sign: "{entity} successfully signed",
      approve: "{entity} successfully approved",
      remove: "{entity} successfully removed",
      link: "{entity} successfully linked",
      complete: "{entity} successfully completed",
      schedule: "{entity} successfully scheduled",
      applied: "{entity} successfully applied",
      activate: "{entity} successfully activated",
      thankYou: "Thank you!",
      questionnaireSubmitted: "Your questionnaire has been successfully submitted.",
      invite: "{entity} successfully invited",
      import: "{entity} successfully imported",
      accept: "{entity} successfully accepted",
      reject: "{entity} successfully rejected",
      cancel: "{entity} successfully canceled",
      done: "{entity} successfully done",
      revoke: "{entity} successfully revoked",
      refer: "{entity} successfully referred",
      referPatientRedirect: "The patient has been referred to Office {office}.",
      send: "{entity} successfully sent",
    },
    error: {
      add: "Failed to add {entity}. Reason: {reason}",
    },
    failure: {
      unknown: "An unknown error occurred",
      add: "Failed to add {entity}. Reason: {reason}",
      edit: "Failed to update {entity}. Reason: {reason}",
      confirm: "Failed to confirm {entity}. Reason: {reason}",
      create: "Failed to create {entity}. Reason: {reason}",
      upload: "Failed to upload {entity}. Reason: {reason}",
      delete: "Failed to delete {entity}. Reason: {reason}",
      save: "Failed to save {entity}. Reason: {reason}",
      sign: "Failed to sign {entity}. Reason: {reason}",
      approve: "Failed to approve {entity}. Reason: {reason}",
      remove: "Failed to remove {entity}. Reason: {reason}",
      invalidEntity: "{entity} is invalid.",
    },
    noEntity: "No {entity} found",
  },
  errors: {
    notValidEmail: "Not a valid email address",
    guardianConsentRequired: "Guardian consent is required for patients under {age} years old",
    guardianMissingCondition:
      "You must have the appropriate permissions to add or select a guardian.",
    noEntityFound: "{entity} not found",
    not_found: "Not found",
    invalid_password: "Incorrect password",
    ageRequirement: "Guardian must be at least {age} years old",
    ageRequirementEntity: "{entity} must be at least {age} years old",
    atleastOneChar: "{field} must have at least 1 character",
    atleastOneItem: "{field} field must have at least 1 item",
    xMoreSlotsCanBeAdded: "Only {remainingSlots} more file(s) can be added (max {maxAttachments})",
    onlyXFilesCanBeAttached: "Only {maxAttachments} file(s) can be attached",
    savingRecording: "Error saving recording",
    fieldIsRequiredField: "{field} is a required field",
    fieldIsRequired: "{field} is required",
    firstSelectField: "First select a @:{field} | First select an @:{field}",
    isAllowedOnlyFor: "This field is allowed only for {field}@:{_field}",
    isAllowedForExistingEntityFor: "This field is allowed only for existing {entity}@:{_entity}",
    notValidWebsite: "Enter a correct format like 'https://domain.com/' with no spaces",
    atLeastOneAddress: "At least one address is required",
    exactlyOnePrimaryAddress: "Exactly one address must be marked as primary",
    addressCannotBeEmpty: "Address cannot be empty",
    phoneCannotBeEmpty: "Phone cannot be empty",
    addressIncomplete: "Each address must be fully filled in",
    cannotConnectToSelf: "A job cannot be connected to itself",
    connectionAlreadyExists: "This connection already exists",
    nameFormat: "Name must contain only letters, spaces, hyphens and apostrophes",
    pageNotFound: "Page Not Found",
    notFoundEntity: "{entity} not found",
    notFoundEntityWithId: "{entity} with ID {id} was not found",
    phoneDoesNotMatchMask: "Please fill format",
    notFoundOrNoAccessToEntity: "{entity} not found or you do not have the necessary access to it",
    someFieldsNotCompleted: "Some required fields are not completed",
    someFieldsRequired: "Some fields are required",
    invalidTaxIdFormat: "Tax ID must be in format ##-#######",
    npiNumberLength: "NPI Number must be exactly 10 digits",
    invalidLicenceNumberFormat:
      "License number must be 4–15 characters: letters, digits, hyphens, or dots only",
    maxLength: "{field} must not exceed {max} characters",
    pleaseAddNote: "Please enter a note",
    unique: "An office with this ID already exists",
    sessionExpired: "Your session has expired. Please log in again.",
    questionnaireInvalid: "Practice is missing or invalid.",
    cannotStartWithZero: "{field} cannot start with zero",
    isNotValidNumber: "{field} is not a valid number",
    noChangeLogData: "No changelog data available.",
    errLoadingChangeLog: "Error loading changelog.",
    errUploadingFile: "Error uploading file.",
    failLoadingChangeLog: "Failed to load changelog.",
    unknownError: "An unknown error occurred. Please try again later.",
    invalidDate: "Invalid date",
    dateMustBeAfter: "Date must be on or after {date}",
    dateMustBeBefore: "Date must be on or before {date}",
    incompleteDateRange: "Select both a start and an end date",
    endDateBeforeStartDate: "End date must be on or after the start date",
    permission_denied: "You do not have permission to perform this action.",
    required: "This field is required",
    minValue: "{field} must be at least {min}",
    maxValue: "{field} must be at most {max}",
    maxPriceMustBeGreaterThanMinPrice: "Max price must be greater than or equal to min price",
    priceMustBeInRange: "Price must be between min price and max price (inclusive)",
    atLeastOneItem: "At least one item is required",
    invalidTime: "Invalid time",
    nothingHereYet: "Nothing here... yet!",
    requestTimeout: "Request timed out after {ms}ms.",
    invalidNumber: "Invalid number",
    invalidFieldOption: "{field} must be a valid option",
    payout_below_minimum: "This amount is below the minimum payout.",
  },
  warnings: {
    shouldBeCapitalized: "Should start with a capital letter",
  },
  dialog: {
    pendingTerms: {
      title: "Updated Policy Documents",
      subtitle: "New terms require your acceptance before you can continue.",
      firstTimeSubtitle: "Please review and accept these documents to continue.",
      documentCount: "{count} document | {count} documents",
      readAction: "Read",
      updatedBadge: "Updated",
      consentLabel: "I have read and accepted the documents listed above.",
      declineConfirm: {
        title: "Decline and sign out?",
        subtitle:
          "You can't use CoTreatMe without accepting these documents. You'll be signed out, and can accept them next time you log in.",
        confirmButton: "Decline & sign out",
      },
      declineImpersonatingConfirm: {
        title: "Decline and stop impersonating?",
        subtitle:
          "You'll return to your own account, leaving these documents unaccepted for {name}. Accepting instead would record the agreement in their name, not yours.",
        fallbackName: "the staff member you're impersonating",
        confirmButton: "Decline & stop impersonating",
      },
    },
    termsAndConditions: {
      title: "Terms & Conditions",
      legalDocuments: "Legal Documents",
      subtitle: "Please review and accept the following before continuing.",
      checkboxPrefix: "I have read and accepted the",
      termsCheckboxLink: "Terms and Conditions",
      businessAssociateAgreementLink: "Business Associate Agreement",
      alreadyAccepted: "Already accepted",
    },
    confirmMessage: {
      title: "Confirm",
      subtitle: "Are you sure you want to continue?",
      deleteSubtitle: "Are you sure you want to delete {entity}? This action cannot be undone.",
      deleteNamedSubtitle:
        'Are you sure you want to delete {entity} "{name}"? This action cannot be undone.',
      deactivateSubtitle:
        "Are you sure you want to deactivate {entity}? It will stop working until reactivated.",
      activateSubtitle: "Are you sure you want to activate {entity}?",
      subtitleWithAction: 'Are you sure you want to proceed "{action}@:{_action}"?',
      sureClose: "Are you sure you want to close?",
      unsavedLost: "Any unsaved changes will be lost.",
    },
    form: {
      cancel: {
        title: "Cancel Confirmation",
        text: "Discard changes? You have unsaved edits. Save to keep your work, or discard to lose it.",
        textWithDraft:
          "Discard changes? You have unsaved edits. Save as draft to keep your work, or discard to lose it.",
      },
      save: {
        title: "Confirm Save",
        text: "Once you select Save & Confirm, your submission will be locked and can no longer be edited. To make changes later, choose Save Draft instead.",
        modText:
          "Once you select {action}, your submission will be locked and can no longer be edited. To make changes later, choose Save Draft instead.",
      },
      positionSaveConfirmation: {
        title: "Position save confirmation",
        text: "You have unsaved node positions. Save to keep your changes, or discard to lose them.",
      },
    },
  },
  components: {
    checkBoxField: {
      defaultTrue: "Yes",
      defaultFalse: "No",
    },
  },
  compactView: {
    progress: "{answered} of {total} answered",
    filterAll: "All sections",
    filterAnswered: "Answered",
    filterUnanswered: "Unanswered",
    allAnsweredTitle: "No unanswered sections",
    allAnsweredDescription:
      "Every section of this questionnaire has been answered. Review them from the Answered tab.",
    openAnswered: "Back to answered sections",
    nothingAnsweredTitle: "No answered sections yet",
    nothingAnsweredDescription: "None of the sections of this questionnaire has been answered yet.",
    openUnanswered: "Show unanswered sections",
    allHiddenTitle: "All sections are hidden",
    allHiddenDescription:
      "Your hidden sections are saved for your next visits. Bring back the ones you need from the Hidden tab.",
    openHidden: "Show hidden sections ({count})",
    files: "No files | {count} file | {count} files",
  },
  states: {
    loading: "loading",
    notAvailable: "Not available",
    empty: "Nothing here yet.",
    emptyShort: "Empty",
    notAnswered: "Not answered",
  },
  labels: {
    legend: "Legend",
    phases: "Phases",
    nodeSpacing: "Node Spacing",
    rankSpacing: "Rank Spacing",
    noDescription: "No description",
  },
  dateRangePresets: {
    title: "Quick ranges",
    pickADay: "Pick a day",
    current: "Current",
    past: "Past",
    future: "Future",
    lastWeek: "Last week",
    lastMonth: "Last month",
    lastYear: "Last year",
    thisYear: "This year",
    tomorrow: "Tomorrow",
    nextWeek: "Next week",
    nextMonth: "Next month",
    nextYear: "Next year",
    next7Days: "Next 7 days",
    next30Days: "Next 30 days",
    next90Days: "Next 90 days",
  },
  loading: {
    treatmentPlan: "Loading treatment plan...",
  },
  legend: {
    signalTypes: "Signal Types",
    system: "System",
    manual: "Manual",
    automatic: "Automatic",
    recurring: "Recurring",
    ui_control: "UI Control",
    connectionTypes: "Connection Types",
    connections: {
      and: "AND (Solid)",
      or: "OR (Dots)",
      backloop: "Backloop (Purple with arrows)",
    },
    handles: "Handles",
    handleDescription: "Top=In, Bottom=Out",
    workflowDescription: "Treatment plan workflow",
    phaseColors: "Phase Colors",
    helperLines: "Helper Lines",
  },
  stats: {
    jobs: "Jobs",
    connections: "Connections",
    days: "days",
  },
  sentry: {
    feedback: "Report a Bug",
  },
  multistepFlow: {
    stepOf: "Step {current} of {total}",
  },
  noFiles: "No files",
  file: {
    dragAndDrop: "Drag & Drop",
    clickToBrowse: " or browse",
    tapToUpload: "Tap to upload",
    filename: "Filename",
    cannotBeRemoved: "Cannot be removed",
    failedToLoad: "Failed to load file",
    noInlinePreview: "No inline preview",
    noInlinePreviewHint: "This file type cannot be shown here. Download it to open in another app.",
    size: "Size",
    uploadedAt: "Uploaded at",
    selectFile: "Select File | Select Files",
    error: {
      invalidFileType: "Invalid file type: {fileName}. Supported types: {acceptedTypes}",
      invalidFileSize: "File {fileName} is too large. Maximum size is {maxSize}",
      maxFilesReached: "Maximum {max} files allowed",
      uploadInProgress: "Upload in progress",
    },
    acceptedType: {
      image: ".jpeg .jpg .png .svg .webp",
      audio: ".aac .flac .m4a, .mp3 .ogg .wav",
      video: ".avi .mkv .mov .mp4 .webm",
      document: ".doc .docx .pdf .ppt .pptx .xls .xlsx",
      supportingDocument: ".jpeg .jpg .png .svg .webp .pdf .doc .docx .xls .xlsx",
      text: ".csv .json .md .txt .xml .yaml .yml",
      model: ".ply .stl",
      "3d": ".ply .stl",
      application: ".7z .dmg .exe .iso .rar .zip",
      unknown: "",
    },
    notAVideo: "Selected file is not a video",
  },
  dashboard: {
    title: "Patients",
  },
  dateInterval: {
    today: "Today",
    yesterday: "Yesterday",
    this_week: "This week",
    this_month: "This month",
  },
  dateLookback: {
    "24_hours": "Last 24h",
    "7_days": "Last 7 days",
    "30_days": "Last 30 days",
    "90_days": "Last 90 days",
  },
  navbar: {
    all: "All Patients",
    paths: {
      analytics: "Analytics",
      administrative: "Administrative",
      messages: "Messages",
      backoffice: "Backoffice",
    },
    greetings: "Hello {name}{title}",
    educationTitles: {
      dds: "DDS",
      dmd: "DMD",
      dds_phd: "DDS Phd",
      dmd_phd: "DMD Phd",
    },
    menuUser: {
      adminSettings: "Platform control",
      permissions: "Current Permissions",
      news: "What's new",
      help: "Tutorial",
      logout: "Logout",
    },
    findMoreAboutUs: "Find out more about us",
    titles: {
      navigation: "Navigation",
      other: "Other",
    },
    roomsDock: {
      peekOpen: "Show rooms",
    },
    breadcrumbs: "Breadcrumbs",
  },
  tables: {
    search: "Search",
    searchLastname: "Search by last name",
    filters: "Filters",
    resetFilter: "Reset filter",
    noData: "No data available",
    empty: {
      title: "Nothing here yet",
      description:
        "There's nothing to show at the moment. New items will appear here once they're added.",
    },
    noResults: {
      title: "No results found",
      description:
        "Nothing matches your current search or filters. Try broadening your search or adjusting the active filters.",
    },
    searchByNameOrEmail: "Search by name or email",
    searchByName: "Search by name",
    searchByNameOrAddress: "Search by name or address",
    searchByNameOrWebsite: "Search by name or website",
    searchByNameOrTaxId: "Search by name or tax ID",
    searchByOfficeOrPracticeName: "Search by office or practice name",
  },
  language: {
    keys: {
      en: "🇺🇸 English",
      es: "🇪🇸 Spanish",
    },
  },
  medias: {
    uploadFile: "Upload File",
    recordAudio: "Record Audio",
    recording: "Recording...",
    audioNotSupported: "Your browser does not support audio recording",
    noRecordingToSave: "Record seems to be empty, please try again",
    recordingSaveError: "Error saving recording, please try again",
    recordingError: "Something went wrong, please try again",
    microphonePermissionDenied: "Microphone permission denied",
    microphoneNotFound: "Microphone not found",
    microphoneError: "Microphone error",
    recordingSaved: "Recording successfully saved",
    recordingTimeLimitReached: "Recording time limit reached",
    audioLoadError: "Could not load audio preview",
  },
  fields: {
    sections: {
      general: "General",
      contact: "Contact",
      insurance: "Insurance",
      myOffices: "My Offices",
      offices: "Offices",
      officesPracticesHeading: "Practices",
      myPractices: "My Practices",
      practicesWithinDso: "Practices within the {name} DSO",
      officesWithinDso: "Offices within the {name} DSO",
      affiliatedOffices: "Affiliated offices",
      interest: "Interest",
      responsiblePersons: "Responsible Persons",
      addresses: "Addresses",
      dates: "Dates",
      documents: "Documents",
      billing: "Billing",
      invoices: "Invoices",
      transactionHistory: "Transaction History",
      persons: "Team",
      pricing: "Pricing",
      apiKey: "API Keys",
      qrCodes: "QR Codes",
      paymentMethods: "Payment Methods",
      payouts: "Payouts",
    },
    actions: "Actions",
    name: "Name",
    url: "Url",
    nameOfEntity: "Name of {entity}",
    description: "Description",
    firstName: "First Name",
    middleName: "Middle Name",
    lastName: "Last Name",
    picture: "Picture",
    secondaryLanguage: "Secondary Language",
    status: "Status",
    professionalStatus: "Professional Status",
    referralStatus: "Referral Status",
    birthDate: "Date of Birth",
    bulkPhotos: "Bulk photos",
    age: "Age",
    createdAt: "Created at",
    completedAt: "Completed at",
    updatedAt: "Updated at",
    dateOfSignature: "Date of signature",
    nextAnniversaryDate: "Anniversary date",
    effectiveDate: "Go-live Date",
    category: "Category",
    language: "Language",
    preferredLanguage: "Preferred Language",
    preferredLanguageShort: "Pref. Language",
    preferredName: "Preferred Name",
    smileConcerns: "Smile Concerns",
    smileConcernsPlaceholder: {
      public: "What is your main concern for your smile?",
      internal: "What is the patient's main concern for their smile?",
    },
    pms: "PMS",
    copy_of_contract: "Copy of contract",
    statusOptions: {
      active: "Active",
      notActive: "Not Active",
      activeEntity: "Active {entity}",
      inactive: "Inactive",
      inactiveEntity: "Inactive {entity}",
      onboarding: "Onboarding",
      setup_issues: "Setup issues",
      dormant: "Dormant",
      draft: "Draft",
      signed: "Signed",
      cancelled: "Cancelled",
      expired: "Expired",
      suspended: "Suspended",
    },
    education: "Dental Credential",
    sex: "Sex",
    sexOptions: {
      MA: "Male",
      FE: "Female",
    },
    type: "Role",
    type2: "Type",
    types: {
      orthodontist: "Orthodontist | ORT",
      ort: "Orthodontist | ORT",
      ortho: "Orthodontist | ORT",
      admin: "Administrator",
      practice_assistant: "Practice Assistant | PA",
      treatment_coordinator: "Treatment Coordinator | TC",
      tc: "Treatment Coordinator | TC",
      hygienist: "Hygienist | H",
      gp: "General Practitioner | GP",
      business_support: "Business Support | BS",
      gp_practice_assistant: "GP Practice Assistant | GPPA",
      ortho_practice_assistant: "Orthodontist Practice Assistant | OPA",
      gp_office_manager: "GP Office Manager | GPOM",
      ortho_office_manager: "Orthodontist Office Manager | OOM",
      accounting_finance: "Accounting / Finance | AC",
      doctor: "Doctor",
      referral_recivier: "Receiver",
      referral_sender: "Cooperating Admissions Office",
      owner: "Sender",
    },
    teamMember: "Team Member | Team Members",
    website: "Website URL",
    company: "Practice",
    practiceType: "Practice type",
    companyName: "Practice Name",
    parentCompany: "Parent Orthodontist Practice",
    selectPractice: "Select Practice",
    placeOfEducation: "Place Of Education",
    preferredCommunicationChannel: "Preferred Communication Channel",
    preferredCommunicationChannelShort: "Channel Preference",
    preferredCommunicationChannelOptions: {
      email: "E-mail",
      phone: "Phone",
    },
    bank: "Bank",
    groups: "Role",
    linkedRole: "Linked Role",
    selectExistingStaffMember: "Select existing staff member",
    noResponsiblePersonsAdded: "No responsible persons added.",
    orthoCompany: "Orthodontist Practice | Orthodontist Practices",
    gpCompany: "GP Practice | GP Practices",
    bankRoutingNumber: "Bank ABA Routing Number",
    bankAccountNumber: "Bank Account Number",
    email: "Email | Emails",
    yourEmail: "Your Email",
    primary: "Primary",
    emailPlaceholder: "Enter email",
    firstNamePlaceholder: "Enter first name",
    lastNamePlaceholder: "Enter last name",
    middleNamePlaceholder: "Enter middle name",
    preferredNamePlaceholder: "Enter preferred name",
    from: "From",
    to: "to",
    showAll: "Show all",
    sortBy: "by Date",
    date: "Date",
    amount: "Amount",
    startDate: "Start Date",
    taxId: "TAX ID/EIN",
    endDate: "End Date",
    dateRange: "Date Range",
    selectDateRange: "Select a date range",
    selectWeek: "Select a week",
    legalEntityName: "Legal Entity Name",
    brandName: "Brand Name",
    phone: "Phone | Phones",
    phoneNumber: "Phone number | Phone numbers",
    prefixCountry: "Country Prefix",
    phonePrefixAutoFill: {
      practicePhone: "Default prefix from your practice phone number",
      practiceCountry: "Default prefix from your practice address country",
      companyPhone: "Default prefix from your practice phone number",
      companyCountry: "Default prefix from your practice country",
      companyAddressCountry: "Default prefix from your practice address country",
      staffPhone: "Default prefix from your profile phone number",
      browserLocale: "Default prefix from your browser language setting",
    },
    prefix: "Prefix",
    number: "Number",
    secondary: "Secondary",
    selectPrefixFirst: "Select country prefix first",
    address: "Address | Addresses",
    placeholder: "Type to search for an address",
    noAddressData: "No addresses were found, please add a more detailed entry",
    noResults: "No results",
    multiselect: {
      searchPlaceholder: "Type to filter...",
      selectedCount: "Selected ({count})",
      clearAll: "Clear all",
      noResults: "No items found",
      hiddenCount: "+{count}",
    },
    id: "ID",
    placeId: "Place ID",
    plusCode: "Plus Code",
    formattedAddress: "Formatted Address",
    streetAddress: "Street Address",
    practiceId: "Office ID",
    streetNumber: "Street Number",
    route: "Route",
    country: "Country",
    administrativeAreaLevel1: "State / Province / Region",
    administrativeAreaLevel2: "County / District",
    administrativeAreaLevel3: "Municipality",
    administrativeAreaLevel4: "Administrative Area Level 4",
    administrativeAreaLevel5: "Administrative Area Level 5",
    administrativeAreaLevel6: "Administrative Area Level 6",
    administrativeAreaLevel7: "Administrative Area Level 7",
    colloquialArea: "Colloquial Area",
    locality: "City",
    sublocality: "Locality",
    neighborhood: "Neighborhood",
    premise: "Premise",
    subPremise: "Sub-premise",
    postalCode: "Postal Code",
    postalAddressLines: "Postal Address Lines",
    postalLocality: "Postal Locality",
    latitude: "Latitude",
    longitude: "Longitude",
    insurance: "Insurance | Insurances",
    provider: "Provider",
    subscriberId: "Subscriber ID",
    validFrom: "Valid from",
    validTo: "Valid to",
    office: "Office | Offices",
    primaryOffice: "Primary",
    photo: "Photo",
    patientPhoto: "Patient photo",
    teamMemberPhoto: "Team Member photo",
    companyLogo: "Practice logo",
    practiceLogo: "Office logo",
    licence: "License | Licenses",
    licenceNumber: "License Number | Owner Doctor Dental License Number",
    licenseExpirationDate: "Expiration Date",
    licenceExpirationDate: "Expiration Date",
    licenceState: "License State | State Of Issuance",
    licenceStateOptions: {
      alabama: "Alabama",
      alaska: "Alaska",
      arizona: "Arizona",
      arkansas: "Arkansas",
      california: "California",
      colorado: "Colorado",
      connecticut: "Connecticut",
      delaware: "Delaware",
      florida: "Florida",
      georgia: "Georgia",
      hawaii: "Hawaii",
      idaho: "Idaho",
      illinois: "Illinois",
      indiana: "Indiana",
      iowa: "Iowa",
      kansas: "Kansas",
      kentucky: "Kentucky",
      louisiana: "Louisiana",
      maine: "Maine",
      maryland: "Maryland",
      massachusetts: "Massachusetts",
      michigan: "Michigan",
      minnesota: "Minnesota",
      mississippi: "Mississippi",
      missouri: "Missouri",
      montana: "Montana",
      nebraska: "Nebraska",
      nevada: "Nevada",
      new_hampshire: "New Hampshire",
      new_jersey: "New Jersey",
      new_mexico: "New Mexico",
      new_york: "New York",
      north_carolina: "North Carolina",
      north_dakota: "North Dakota",
      ohio: "Ohio",
      oklahoma: "Oklahoma",
      oregon: "Oregon",
      pennsylvania: "Pennsylvania",
      rhode_island: "Rhode Island",
      south_carolina: "South Carolina",
      south_dakota: "South Dakota",
      tennessee: "Tennessee",
      texas: "Texas",
      utah: "Utah",
      vermont: "Vermont",
      virginia: "Virginia",
      washington: "Washington",
      west_virginia: "West Virginia",
      wisconsin: "Wisconsin",
      wyoming: "Wyoming",
      district_of_columbia: "District of Columbia",
      american_samoa: "American Samoa",
      guam: "Guam",
      northern_mariana_islands: "Northern Mariana Islands",
      puerto_rico: "Puerto Rico",
      us_virgin_islands: "US Virgin Islands",
      alberta: "Alberta",
      british_columbia: "British Columbia",
      manitoba: "Manitoba",
      new_brunswick: "New Brunswick",
      newfoundland_and_labrador: "Newfoundland and Labrador",
      northwest_territories: "Northwest Territories",
      nova_scotia: "Nova Scotia",
      nunavut: "Nunavut",
      ontario: "Ontario",
      prince_edward_island: "Prince Edward Island",
      quebec: "Quebec",
      saskatchewan: "Saskatchewan",
      yukon: "Yukon",
    },
    notes: "Notes",
    notesPlaceholder: "Write additional info",
    comment: "Comment",
    datePlaceholder: "Select date",
    time: "Time",
    default: "Default",
    system: "System",
    apiKey: "API Key",
    platform: "Platform",
    slug: "Platform",
    doctorId: "Doctor ID",
    location: "Location",
    defaultPatientProvider: "Default Patient Provider",
    referralConsultationAppointmentTypeWhitelist: "Referral Consultation Appointment Types",
    selfSchedulingAppointmentTypeMinor: "Self-Scheduling Appointment Type (Minor)",
    selfSchedulingAppointmentTypeAdult: "Self-Scheduling Appointment Type (Adult)",
    apiKeys: {
      title: "External API Key | External API Keys",
      addKey: "Add key",
      createDisabledAllPlatformsUsed: "Every platform already has an API key.",
      createDisabled: "Loading available platforms…",
      metadata: "Metadata",
      isActive: "Is Active",
      practiceId: "Practice ID",
      quickstartId: "Quickstart ID",
      sharedToPractices: "Shared with practices",
      sharedToPracticesHint: "Only practices you are linked to can be shared with.",
      location: "Location",
      defaultPatientProvider: "Default Patient Provider",
      referralConsultationAppointmentTypeWhitelist: "Referral Consultation Appointment Types",
      selfSchedulingAppointmentTypeMinor: "Self-Scheduling Appointment Type (Minor)",
      selfSchedulingAppointmentTypeAdult: "Self-Scheduling Appointment Type (Adult)",
      appointmentTypeWhitelistHint: "Comma-separated Cloud9 appointment type IDs",
      platformMetadata: {
        username: "Username",
        password: "Password",
        accountId: "Account ID",
        oauthHostName: "OAuth Host Name",
        webhookHmacSecrets: "Webhook HMAC Secrets",
        oauthBase: "OAuth Base URL",
        clientId: "Client ID",
        clientSecret: "Client Secret",
        oauthStateSecret: "OAuth State Secret",
        pairCallbackUrl: "Pair Callback URL",
      },
      platforms: {
        options: {
          us: "US",
          us_partner: "US partner",
          eu2: "EU2",
          jp1: "JP1",
          ap1: "AP1",
          "dm-us": "DM US",
          "dm-us-partner": "DM-US",
          "dm-eu2": "DM EU2",
          "dm-jp1": "DM JP1",
          "dm-ap1": "DM AP1",
          "od-generic": "OD GENERIC",
        },
      },
    },
    partnerCompany: "Partner",
    initiatorCompany: "Initiator",
    signMethod: "Sign method",
    quickstartId: "Quickstart (initial quickstart for the patients)",
    quickstartIdPlaceholder: "First, you need to fill API Key, Platform and Doctor ID",
    quickstartProtocol: "Quickstart protocol",
    practice: "Office",
    practiceName: "Office Name",
    state: "State",
    taxonomyCode: "Taxonomy Code",
    smile_concerns: "Smile concerns",
    personalMessage: "Personal Message",
    invitationType: "Invitation Type",
    externalCalendarUrl: "External calendar URL",
    timeZone: "Time zone",
    companyModel: {
      taxId: "Legal Entity's TAX ID/EIN",
      npiNumber: "National Provider Identifier (Type 2)",
    },
    relationship: {
      grandparent: "Grandparent",
      guardian: "Legal guardian",
      other: "Other",
      parent: "Parent",
      sibling: "Sibling",
      spouse: "Spouse",
    },
    orthoProposedPlan: {
      skeletalClass: "Skeletal Class",
      dentitionType: "Dentition Type",
      radiographicFindings: "Radiographic Findings",
      tmj: "TMJ",
      molarClassificationLabelRight: "Right Molar Classification",
      molarClassificationLabelLeft: "Left Molar Classification",
      midline: "Midline",
      overbite: "Overbite",
      overjet: "Overjet",
      crossbitePresent: "Crossbite Present",
      upperSpacing: "Upper Spacing",
      lowerSpacing: "Lower Spacing",
      crowdingUpperLabel: "Upper Crowding",
      crowdingLowerLabel: "Lower Crowding",
      toothSizeDiscrepancies: "Tooth Size Discrepancies",
      mandibularPlaneAngle: "Mandibular Plane Angle",
      canineClassificationLabelRight: "Right Canine Classification",
      canineClassificationLabelLeft: "Left Canine Classification",
      upperCentralIncisorPosition: "Upper Central Incisor Position",
      gingivalDisplayAtSmile: "Gingival Display at Smile",
      gingivalContours: "Gingival Contours",
      smileArc: "Smile Arc",
      treatTheAdultPosteriorCrossbite: "Treat The Adult Posterior Crossbite",
      tmjNotes: "TMJ notes",
      caseType: "Case Type",
      treatmentTime: "Treatment time",
    },
    orthoNeeds: {
      pendingDentalWorkNotes: "Pending Dental Work Notes",
      orthoClearanceNotes: "Ortho Clearance Notes",
      periodicallClearanceNotes: "Periodontal Clearance Notes",
    },
    password: "Password",
    newPassword: "New password",
    consent: "Consent",
    defaultForInvite: "For Invite",
    ageOfInvitee: "Invitee Age",
    ageOfUpdate: "Updated",
    treatmentTypes: {
      title: "Treatment Type",
      cotreatment: "CoTreatment",
      cotreatme: "CoTreatMe",
      referral_free: "Referral",
      referral_paid: "Records",
      referral_paid_in: "Referral Paid In",
      referral_paid_out: "Referral Paid Out",
      referral_with_records_in: "Records Sender",
      referral_with_records_out: "Records Receiver",
      referral: "Referral",
      referral_internal: "Referral Internal",
      select_treatment: "Select Plan",
    },
    product: "Product | Products",
    minPrice: "Min Price",
    maxPrice: "Max Price",
    price: "Price",
    item: "Item",
    referralDefaultPriceTypePricing: {
      title: "Pricing Type",
      per_file: "Per File",
      per_pack: "Per Case",
    },
    referralDefaultPriceTypePatientFile: {
      title: "Patient File Type",
      ioscan: "I/O Scan",
      xray: "X-Ray",
      photo: "Photo",
      composite_view: "Composite Photos",
      compositeViewSubtitle: "Only up to 8 images.",
    },
    mso: "MSO | MSOs",
    ownerPractice: "Admitting Office",
    IPRReduction: "IPR reduction",
    title: "Title",
    currency: "Currency",
    requestedBy: "Requested by",
    referralContractStatus: {
      draft: "Waiting for signature",
    },
  },
  alerts: {
    newVersionWaitingUntilFormDone:
      "A new version is ready. This page will refresh automatically when you finish your changes.",
    phonesImplementationWaiting: "Phone implementation is waiting for backend",
    rotateDevice: "Please rotate your device to landscape for the best experience.",
  },
  flowColors: {
    phases: {
      "0": {
        name: "No Phase",
      },
      "1": {
        name: "Phase 1",
      },
      "2": {
        name: "Phase 2",
      },
      "3": {
        name: "Phase 3",
      },
      "4": {
        name: "Phase 4",
      },
      "5": {
        name: "Phase 5",
      },
    },
  },
  action: {
    actions: "Actions",
    loadMore: "Load more",
    confirm: "Confirm | Confirmation",
    confirmEntity: "Confirm {entity}",
    cancel: "Cancel",
    cancelEntity: "Cancel {entity}",
    changeType: "Change Role",
    manage: "Manage",
    back: "Back",
    backEntity: "Back {entity}",
    add: "Add",
    addEntity: "Add {entity}",
    addJob: "Add Job",
    addExistingEntity: "Add existing {entity}",
    layout: "Layout",
    edit: "Edit",
    editEntity: "Edit {entity}",
    deactivate: "Deactivate",
    deactivateEntity: "Deactivate {entity}",
    activate: "Activate",
    activateEntity: "Activate {entity}",
    editDetails: "Edit Details",
    editing: "Editing",
    detail: "Detail",
    show: "Show",
    hide: "Hide",
    compactView: "Compact",
    detailedView: "Detailed",
    customize: "Customize",
    showMore: "Show more",
    showLess: "Show less",
    suspend: "Suspend",
    view: "View",
    viewEntity: "View {entity}",
    viewAll: "View All",
    viewPending: "View Pending",
    viewPhase: "View Phase",
    validate: "Validate",
    validateEntity: "Validate {entity}",
    save: "Save",
    update: "Update",
    savePlan: "Save Plan",
    apply: "Apply",
    saveEntity: "Save {entity}",
    saveDraft: "Save Draft",
    saveAndConfirm: "Save & Confirm",
    saveAndSend: "Save & Send",
    select: "Select",
    selectEntity: "Select {entity}",
    selectSubtree: "Select Subtree",
    review: "Review",
    reviewEntity: "Review {entity}",
    filter: "Filter",
    filterEntity: "Filter {entity}",
    create: "Create",
    createEntity: "Create {entity}",
    createConnection: "Create Connection",
    orCreate: "or create a new one",
    orCreateEntity: "or create a new {entity}",
    setup: "Setup",
    setupEntity: "Setup {entity}",
    remove: "Remove",
    removeEntity: "Remove {entity}",
    reset: "Reset",
    approve: "Approve",
    approveEntity: "Approve {entity}",
    schedule: "Schedule",
    scheduleEntity: "Schedule {entity}",
    upload: "Upload",
    uploadEntity: "Upload {entity}",
    confirmAndSend: "Confirm and send",
    confirmAndSendEntity: "Confirm and send {entity}",
    regenerate: "Re-generate",
    regenerateEntity: "Re-generate {entity}",
    generate: "Generate",
    generateEntity: "Generate {entity}",
    impersonate: "Impersonate",
    impersonateDescription: "Are you sure you want to impersonate {user}?",
    stopImpersonating: "Stop impersonating",
    hideMetadata: "Hide metadata",
    editMetadata: "Edit metadata",
    impersonateTooltip: "Log in as this user to see their interface",
    copy: "Copy",
    copyEntity: "Copy {entity}",
    externalCalendar: "External Calendar",
    link: "Link",
    linkEntity: "Link {entity}",
    unlink: "Unlink",
    discardChanges: "Discard Changes",
    close: "Close",
    pause: "Pause",
    resume: "Resume",
    delete: "Delete",
    duplicate: "Duplicate",
    deleteEntity: "Delete {entity}",
    next: "Next",
    continue: "Continue",
    verify: "Verify",
    enter: "Enter",
    finish: "Finish",
    enterEntity: "Enter {entity}",
    openTimePicker: "Open time picker",
    clear: "Clear",
    complete: "Complete",
    done: "Done",
    sendUpdate: "Send Update",
    accept: "Accept",
    decline: "Decline",
    resend: "Resend",
    search: "Search",
    searchEntity: "Search {entity}",
    saveAndComplete: "Save & Complete",
    import: "Import",
    export: "Export",
    download: "Download",
    addItem: "Add Item",
    sign: "Sign",
    signOffering: "Create Draft Contract",
    createContract: "Create a Contract",
    revoke: "Revoke",
    previous: "Previous",
    fill: "Fill {entity}",
    replace: "Replace",
    setPrimary: "Set Primary",
    reject: "Reject",
    later: "Later",
  },
  badges: {
    dev: "DEV",
  },
  entity: {
    profile: "Profile",
    preferences: "Preferences",
    permissions: "My Permissions",
    count: "{entity} count",
    inTotal: "{entity} in total",
    organization: "Organization",
    total: "{entity} total",
    stats: "{entity} stats",
    patient: "Patient | Patients",
    patientFile: "Patient File | Patient Files",
    staff: "Member | Team Member | Team Members",
    practiceStaff: "Office Member",
    guardian: "Guardian | Guardians",
    newGuardian: "new Guardian | new Guardians",
    existingGuardian: "existing Guardian | existing Guardians",
    company: "Practice | Practices",
    practice: "Office | Offices",
    gpCompany: "GP Practice | GP Practices",
    gpPractice: "GP Office | GP Offices",
    gp: "GP | GPs",
    ort: "ORT | ORTs",
    ortho: "Orthodontist | Orthodontists",
    orthoPcCompany: "Orthodontist PC Practice | Orthodontist PC Practices",
    orthoCompany: "Orthodontist Practice | Orthodontist Practices",
    partnerCompany: "Partner | Partners",
    initiatorCompany: "Initiator | Initiators",
    orthoPractice: "Orthodontist Office | Orthodontist Offices",
    insuranceNetwork: "Insurance Network | Insurance Networks",
    insuranceCompany: "Insurance Company | Insurance Companies",
    platform: "Integration Platform | Integration Platforms",
    responsiblePerson: "Responsible Person | Responsible Persons",
    contract: "Contract | Contracts",
    policyDocument: "Policy Document | Policy Documents",
    report: "Patient Export | Patient Exports",
    assistant: "Assistant",
    orthodontist: "Orthodontist | Orthodontists",
    generalPractitioner: "General Practitioner | General Practitioners",
    hygienist: "Hygienist | Hygienists",
    treatmentCoordinator: "Treatment Coordinator | Treatment Coordinators",
    treatmentFlow: "Treatment Flow | Treatment Flows",
    treatmentFlowJob: "Treatment Flow Job | Treatment Flow Jobs",
    treatmentFlowBackLoop: "Treatment Flow Back Loop | Treatment Flow Back Loops",
    treatmentFlowPlan: "Treatment Flow Plan | Treatment Flow Plans",
    treatmentPlan: "Treatment Plan | Treatment Plans",
    connection: "Connection | Connections",
    nodePositions: "node positions",
    qrCode: "QR code | QR codes",
    file: "File | Files",
    contact: "Contact | Contacts",
    orthoNeedsPlan: "GP Questionnaire | GP Questionnaires",
    orthoProposedPlan: "Diagnostic Questionnaire | Diagnostic Questionnaires",
    nextVisitInstruction: "Next Visit Instruction | Next Visit Instructions",
    instruction: "Instruction | Instructions",
    meeting: "Meeting | Meetings",
    financingPlan: "Financing Plan | Financing Plans",
    orderAligners: "Order Aligners | Order Aligners",
    alignerDelivery: "Aligner Delivery | Aligner Deliveries",
    alignerApplication: "Aligner Application | Aligner Applications",
    tcAppointment: "TC Appointment | TC Appointments",
    notification: "Notification Center | Notifications",
    scheduling: "Scheduling",
    administrative: "Administrative",
    administrativeAssistant: "Administrative Assistant | Administrative Assistants",
    dashboard: "Dashboard",
    invite: "Invite | Invites",
    referral: "Referral | Referrals",
    settings: "Settings",
    adminSettings: "Admin Settings",
    role: "Role | Roles",
    group: "Group | Groups",
    xray: "X-Ray | X-Rays",
    image: "Image | Images",
    scan: "Scan | Scans",
    compositeView: "Composite View",
    questionnaire: "Questionnaire | Questionnaires",
    annotation: "Annotation | Annotations",
    alignerDeliveryInstructions: "Aligner Delivery Instructions",
    nextVisitInstructions: "Next Visit Instructions",
    finalDebondInstructions: "Final Debond Instructions",
    instructionsResult: "Instruction Comment",
    product: "Product | Products",
    invitation: "Invitation | Invitations",
    records: "Record | Records",
    referralAppointment: "Referral Appointment | Referral Appointments",
    doctor: "Doctor | Doctors",
    mso: "MSO | MSOs",
    invoice: "Invoice | Invoices",
    job: "Job | Jobs",
    contactInfo: "Contact Information",
    chat: "Chat | Chats",
    subscription: "Subscription",
    customPlan: "Custom Plan | Custom Plans",
    dso: "DSO",
    logo: "Logo | Logos",
    payout: "Payout | Payouts",
  },
  tooltip: {
    annotationEditor: "Open annotation editor",
    annotationList: "Open annotations list",
    openOnBlankPage: "Open on blank page",
    download: "Download",
    close: "Close",
    zoom: "Zoom",
    back: "Back",
    change: "Change",
    pause: "Pause",
    resume: "Resume",
    stop: "Stop",
    addComment: "Add comment",
    markDone: "Mark done",
    markUnDone: "Mark not done",
    actionsNotAvailable: "Protocols actions are not available yet",
    version: "Version | Versions",
    sendToChat: "Send to chat",
    isInQuestionaire: "File from questionnaire",
    edit: "Edit",
    commingSoon: "Coming soon",
    exitFullscreen: "Exit fullscreen",
    fullscreen: "Fullscreen",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    nextPage: "Next page",
    previousPage: "Previous page",
    "3D": "Open 3D",
    exit3D: "Exit 3D",
  },
  tour: {
    dashboard: {
      account: {
        title: "Your Account",
        description: "Access to your user account and its settings is located under the user icon.",
      },
      accountMobile: {
        description:
          "Access to the main menu and your user account settings is located under the grid icon.",
      },
      addPatient: {
        title: "Add Patient",
        description: "You can add your first patient here.",
      },
      dashboardsOverview: {
        title: "Dashboards Overview",
        description:
          "A dashboard for your daily work shows your patients organized into tabs based on the next action that needs to be taken.",
      },
      notifications: {
        title: "Notifications",
        description:
          "Anything that requires your attention will be displayed in the notifications, including alerts for new messages.",
      },
    },
    officesContracts: {
      welcome: {
        title: "Organization & Connections",
        description:
          "This tutorial will guide you through the Organization section - your practices, offices, and the connections you hold with other providers.",
      },
      organizationNav: {
        title: "Organization",
        description:
          "Find 'Organization' in the top navigation bar. It groups everything about your own practices, offices and connections in one place.",
      },
      organizationNavMobile: {
        description:
          "Open the main menu and select 'Organization'. It groups everything about your own practices, offices and connections in one place.",
      },
      subNav: {
        title: "Organization Submenu",
        description:
          "The submenu below the navigation bar splits the section into Practices and Offices. Open a practice to manage its connections.",
      },
      practicesPage: {
        title: "Practices",
        description:
          "This page lists all practices you are associated with, together with the number of offices, team members and patients in each. Click a row to open the practice detail.",
      },
      officesPage: {
        description:
          "Here you see every individual office across your practices, with its address and patient count. Next we open a practice to review its connections.",
      },
      connectionsTab: {
        title: "Connections Tab",
        description:
          "Each practice has a Connections tab. This is where you manage contractual relationships with other providers for that practice.",
      },
      connectionsTable: {
        title: "Connected Practices",
        description:
          "This table lists every practice you are connected with and the status of each agreement type. Click a row to open the connection detail.",
      },
      colPractice: {
        title: "Practice Column",
        description:
          "Shows the counterparty practice - or the invitee email when they have not registered yet - and who started the connection.",
      },
      colReferral: {
        title: "Referral Column",
        description:
          "Shows whether a referral agreement is in place between your practice and the counterparty.",
      },
      colRecordsSender: {
        title: "Referral with Records - Sender",
        description:
          "Shows contracts where your practice sends records with the referral. A Draft contract button appears when you can create a new offer.",
      },
      colRecordsReceiver: {
        title: "Referral with Records - Receiver",
        description:
          "Shows contracts where your practice receives referrals along with records from the counterparty.",
      },
      colCotreatment: {
        title: "CoTreatMe Column",
        description:
          "Shows whether both sides have signed the CoTreatMe agreement for this connection. Signing for your practice happens on the banner above the table.",
      },
      signOffering: {
        title: "Create Draft Offer",
        description:
          "The Draft contract button lets you start a referral-with-records offer for this connection. A responsible person must be assigned to your practice before you can create an offer.",
      },
      invite: {
        title: "Invite Practice",
        description:
          "Invite another practice to connect. Invites draw from your practice plan connection pool - when the pool is full, new invites are blocked until a connection is freed or the plan is upgraded.",
      },
      cotreatmentBanner: {
        title: "CoTreatMe Agreement",
        description:
          "CoTreatMe is one agreement per practice you own. Sign it here once - every connection then shows whether the counterpart has also signed.",
      },
      statuses: {
        title: "Agreement Statuses",
        intro: "Each agreement cell can show one of these statuses:",
        signed: {
          description: "the agreement is active and confirmed.",
        },
        draft: {
          description: "a signature is still outstanding on one or both sides.",
        },
        inactive: {
          description: "no agreement has been started for this type.",
        },
        unavailable: {
          description: "the agreement cannot be used right now - for example when the connection is suspended.",
        },
        offer: {
          description: "you can create a draft referral-with-records offer for this connection.",
        },
      },
      end: {
        description:
          "You have completed the Organization & Connections tour. You can replay any tutorial from the Help menu at any time.",
      },
    },
    officeBilling: {
      welcome: {
        title: "Office Billing",
        description:
          "This tutorial will guide you through the billing section of your office. You will learn about the account balance, payment methods, invoices, transactions, and how to create a new invoice.",
      },
      userMenu: {
        title: "Organization Access",
        description:
          "Start by navigating to your organization. Click 'Organization' in the top navigation bar to view all your practices and offices.",
      },
      userMenuMobile: {
        description:
          "Open the main menu and select 'Organization' to navigate to your practices and offices overview.",
      },
      officesPage: {
        title: "Practices Overview",
        description:
          "Here you can see all your practices. Select one to view its details and access the billing section.",
      },
      companyRow: {
        description:
          "Each entry represents a practice with its offices listed below. Click on a practice to view its details.",
      },
      billingTab: {
        title: "Invoices Tab",
        overview:
          "The Invoices tab lists all invoices for your office. The General tab shows your plan and account balance, and payment methods, payouts, and the transaction history each have their own tab.",
      },
      balance: {
        title: "Account Balance",
        description:
          "The balance section shows your current account standing. A positive balance represents a credit, while a negative balance indicates an amount owed. Multiple currencies are displayed separately if applicable.",
      },
      paymentMethods: {
        title: "Payment Methods",
        description:
          "Manage your payment methods here. You can add new cards, set a default payment method, or remove existing ones. The default card is used automatically for invoice payments.",
      },
      billingHistory: {
        title: "Invoice History",
        description:
          "This section lists all your invoices with their status. Open an invoice for details, download a PDF when available, or charge again when the invoice allows it.",
      },
      transactions: {
        overviewWithDetails:
          "The transaction history shows all financial movements on your account, grouped by day. Money coming in is shown in green. Select a payout or invoice number to open its details.",
      },
      end: {
        title: "Tour Complete",
        description:
          "You have completed the Office Billing tour. You now know how to manage your billing and review transactions. You can replay any tutorial from the Help menu.",
      },
      payouts: {
        title: "Payout History",
        withdrawDescription:
          "See every payout sent from your balance and whether it arrived. Open a payout to review details or retry when allowed.",
      },
    },
    tourList: {
      title: "Get Started with CoTreatMe",
      subtitle: "Pick a tour to get started.",
      missingPermissionsReasons: {
        officeBilling: "Practice billing management permission is required.",
        officesContracts: "Practice access and connection management permissions are required.",
      },
      allDoneTitle: "You're all set!",
      allDoneSubtitle: "You've completed all tutorials. You can replay any of them below.",
      startNamed: "Start {name}",
      replayNamed: "Replay {name}",
      skipForNow: "Skip for now",
      tours: {
        dashboardMain: {
          title: "Dashboard Overview",
          description:
            "Learn how to navigate the dashboard, manage patients, and use key features.",
        },
        officesContracts: {
          title: "Organization & Connections",
          description:
            "Navigate the Organization section and manage connections with other practices.",
        },
        officeBilling: {
          title: "Billing & Payments",
          description: "Manage billing, payment methods, invoices and your transaction history.",
        },
      },
    },
    actions: {
      cancel: "Back to Lessons",
    },
  },
  feedbackMessages: {
    contractOffer: {
      title: "Next step: Sign your agreement",
      text: "We have received all the necessary information to prepare the agreement. Check your email to review and sign.",
    },
    acceptInvite: {
      title: "You're all set",
      text: "Start connecting with providers, sending referrals,\nand cotreating cases.",
      action: "Get Started",
    },
    declineInvite: {
      title: "We are sorry to see you go",
      text: "We understand that you have decided to decline the invitation. If you change your mind, feel free to reach out to us.",
    },
    addedMembers: {
      title: "Added team members",
      success: "All team members were added.",
      failure: "Added team members: {success}\nFailed to add: {failure}",
    },
    patientFiles: {
      title: "Files updated",
      addedAll: "Added {count} file(s).",
      addedPartial: "Added {success} file(s). {failure} failed to upload.",
      deletedAll: "Deleted {count} file(s).",
      deletedPartial: "Deleted {success} file(s). {failure} failed to delete.",
    },
  },
  pageError: {
    "401": {
      title: "Unauthorized",
      text: "You don't have permission to access this page.",
      subText: "Please contact your administrator if you believe this is an error.",
    },
    "404": {
      title: "Page not found",
      text: "The page you are looking for doesn't exist.",
      subText: "It might have been removed, or you might have entered the wrong URL.",
    },
    goToHomepage: "Go to Homepage",
    goBack: "Go Back",
    availableSections: "Sections you have access to",
  },
} as const;

export type GenericMessages = typeof generic;
